/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/displays/slides/leaderboard.module.scss';

const propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    draw: PropTypes.shape({}),
    startIndex: PropTypes.number,
    leaderboards: PropTypes.shape({}),
};

const defaultProps = {
    title: null,
    items: null,
    draw: null,
    startIndex: null,
    leaderboards: null,
};

function LeaderboardSlide({ title, items, startIndex, draw }) {
    const themeClassName = useThemeClassName(styles);
    const {
        title: drawTitle = null,
        description: drawDescription = null,
        image: drawImage = null,
        drawingAt = null,
    } = draw || {};

    const { url: drawImageUrl = null } = drawImage || {};

    return (
        <div className={classNames([styles.container, themeClassName])}>
            <div className={styles.leaderboard}>
                {title !== null ? (
                    <div className={styles.titleContainer}>
                        <h2 className={styles.title}>{title}</h2>
                    </div>
                ) : null}
                <div className={styles.items}>
                    {(items || [{ points: 0, value: '---' }]).map(
                        ({ value = null, points = null } = {}, i = 0) => (
                            <div key={`leaderboard-item=${value}`} className={styles.item}>
                                <p className={styles.index}>
                                    {((parseInt(startIndex, 10) || 0) + i + 1)
                                        .toString()
                                        .padStart(2, '0')}
                                </p>
                                <p className={styles.value}>{value}</p>
                                {points !== null ? (
                                    <p className={styles.points}>
                                        {points.toString().padStart(3, '0')}
                                    </p>
                                ) : null}
                            </div>
                        ),
                    )}
                </div>
            </div>
            {draw !== null && drawTitle !== null ? (
                <div className={styles.prize}>
                    <h2 className={styles.title}>{drawTitle}</h2>
                    {drawDescription !== null ? (
                        <p className={styles.description}>{drawDescription}</p>
                    ) : null}
                    {drawImageUrl !== null ? (
                        <img className={styles.image} src={drawImageUrl} alt={drawTitle} />
                    ) : null}
                    {drawingAt !== null ? (
                        <p className={styles.date}>
                            <span>
                                <FormattedMessage
                                    defaultMessage="Drawing on"
                                    description="Draw label"
                                />
                            </span>
                            <br />
                            <FormattedDate value={drawingAt} />
                        </p>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}

LeaderboardSlide.propTypes = propTypes;
LeaderboardSlide.defaultProps = defaultProps;

export default LeaderboardSlide;
